import React, { useEffect } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Link, Stack, Typography, useTheme } from '@mui/material';
import { Box } from '@mui/system';
import { Profile } from '@par/shared/types/player';

type PropTypes = {
  closeAnnouncement: () => void;
  openAnnouncement: boolean;
};
export const Announcement = ({
  closeAnnouncement,
  openAnnouncement,
}: PropTypes) => {
  return (
    <Dialog open={openAnnouncement} maxWidth="md" fullWidth>
      <DialogTitle>
        <Typography
          variant="h4"
          my={1}
          textAlign={'center'}
          letterSpacing={2}
          sx={{
            textShadow:
              'rgb(255, 186, 24) 0px 0px 0px, rgb(255, 186, 24) 0px 0px 0px, rgb(255, 186, 24) 0px 0px 16px',
          }}
        >
          PAR MOBILE DAILIES
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ width: '100%', height: '100%' }}>
        <Stack direction="row" spacing={5}>
          <Box
            component="img"
            src={
              'https://res.cloudinary.com/dqlqwdqs9/image/upload/v1698218507/mobile-landing_hcc8rj.png'
            }
            alt="image"
            sx={{ width: '20%', height: 'auto', objectFit: 'contain' }}
          />
          <Stack spacing={4}>
            <Typography>
              We just launched a mobile version of PAR complete with its own set
              of Dailies!
            </Typography>
            <Typography>
              Read more about it on the
              <Link
                sx={{ cursor: 'pointer', marginLeft: 2, marginRight: 2 }}
                href="https://discord.gg/upX48KPfHd"
                target="_blank"
              >
                Discord
              </Link>
              announcements.
            </Typography>
            <Typography>
              Check it out by going to this link on your mobile device:
            </Typography>
            <Typography variant="h6">
              <Link target="_blank" href="https://mobile.par.live">
                mobile.par.live
              </Link>
            </Typography>
          </Stack>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={closeAnnouncement} fullWidth>
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};
